module.exports = __webpack_public_path__ + "static/media/dsc_0026.5c9e2675.jpg";